export enum RotasRelatorios {
	EVAPOTRANSPIRACAO = '/evapotranspiracao',
	QUANTIS_ANUAL = '/quantis-anual',
	VARIAVEIS = '/informacao-sensores',
	VARIAVEISTODOSPOSTOS = '/informacao-todos-sensores',
}
